import { useState } from 'react'
import { activerClient, changerStatut } from '../../api/onboarding'
import { actionsStatut, LIBELLE_STATUT, type ActionStatut, type StatutOnboarding } from '../../api/onboardingRegles'
import { Bloc, Erreur, Info, useAction } from './Briques'

/**
 * Décision : activer, refuser, suspendre, rouvrir, retirer le contrat. Un motif est exigé AVANT l'appel pour
 * refuser/suspendre (la base l'exige aussi). Activer et réactiver : propriétaire seulement (la base aussi).
 * Activer passe par la RPC `activer_client_pme`, qui reporte l'offre choisie sur la fiche du client.
 */
export function SectionDecision({
  clientId, statut, motifActuel, peutGerer, proprietaire, surChange,
}: {
  clientId: string
  statut: StatutOnboarding
  motifActuel: string | null
  peutGerer: boolean
  proprietaire: boolean
  surChange: () => void
}) {
  const [motif, setMotif] = useState('')
  const { occupe, erreur, info, lancer, signaler } = useAction()
  const actions = actionsStatut(statut)
  const besoinMotif = actions.some((a) => a.motifRequis)

  async function decider(a: ActionStatut) {
    if (a.motifRequis && !motif.trim()) { signaler('Un motif est obligatoire pour cette décision.'); return }
    const phrase = a.motifRequis ? `${a.libelle} ?\n\nMotif : ${motif.trim()}` : `${a.libelle} ?`
    if ((a.ton === 'danger' || a.vers === 'actif') && !window.confirm(phrase)) return
    const ok = await lancer(async () => {
      if (statut === 'contrat_signe' && a.vers === 'actif') {
        await activerClient(clientId)
        surChange()
        return 'Client activé : l’offre choisie est reportée sur sa fiche, les courses peuvent lui être créées.'
      }
      await changerStatut(clientId, a.vers, a.motifRequis ? motif : undefined)
      surChange()
      return `Statut : ${LIBELLE_STATUT[a.vers]}.`
    })
    if (ok) setMotif('')
  }

  return (
    <Bloc titre="Décision" lecture={!peutGerer}>
      {motifActuel && (statut === 'refuse' || statut === 'suspendu') && (
        <p className="onb-note">Motif enregistré : « {motifActuel} »</p>
      )}
      {!peutGerer ? (
        <p className="onb-note">Votre rôle consulte le dossier sans le modifier.</p>
      ) : actions.length === 0 ? (
        <p className="onb-note">Aucune décision n’est possible à cette étape.</p>
      ) : (
        <>
          {besoinMotif && (
            <textarea className="onb-motif" placeholder="Motif (obligatoire pour refuser ou suspendre)" value={motif} onChange={(e) => setMotif(e.target.value)} />
          )}
          <div className="onb-actions" style={{ marginTop: 4 }}>
            {actions.map((a) => {
              const interdit = a.proprietaire && !proprietaire
              return (
                <button
                  key={a.vers}
                  className={`btn btn-sm ${a.ton === 'principal' ? 'btn-gold' : 'btn-outline'}`}
                  disabled={occupe || interdit}
                  title={interdit ? 'Réservé au propriétaire.' : undefined}
                  onClick={() => void decider(a)}
                >
                  {a.libelle}
                </button>
              )
            })}
          </div>
          {actions.some((a) => a.proprietaire && !proprietaire) && <p className="onb-note">L’activation est réservée au propriétaire.</p>}
        </>
      )}
      <Erreur texte={erreur} />
      <Info texte={info} />
    </Bloc>
  )
}
